import React from 'react';
import './Subscribe.css';
import lobby from '../assets/lobby.jpg';

const lobbyImg = lobby;

export default function Subscribe() {
  return (
    <section className="subscribe">
      <div className="container">
        <div className="image-wrapper">
          <img src={lobbyImg} alt="Staircase" />
        </div>
        <div className="content">
          <h3>Want to stay in touch?</h3>
          <h2>Subscribe for the latest news &amp; updates</h2>
          <p>
            Stay in the Shadows. Discover What Comes Next.
            Join the haunt from Studio13 and be the first to uncover chilling updates, behind-the-scenes reveals, and exclusive content from our latest horror projects.
          </p>
          <form>
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Your email address" />
            <button type="submit">Subscribe now</button>
          </form>
        </div>
      </div>
    </section>
  );
}
